"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.updateCourseClosure = exports.deleteCourseClosure = exports.addCourseClosure = exports.getCourseClosure = exports.getCourseClosures = void 0;
const _ = require("lodash");
const getCourseClosures = async (supabase, course_id) => {
    const { data, error } = await supabase
        .from("course_closures")
        .select(`*`)
        .eq("course_id", course_id)
        .order("end_date", { ascending: true });
    if (!error)
        return data;
    return error;
};
exports.getCourseClosures = getCourseClosures;
const getCourseClosure = async (supabase, id) => {
    const { data, error } = await supabase
        .from("course_closures")
        .select(`*`)
        .eq("id", id)
        .single();
    if (!error)
        return data;
    return error;
};
exports.getCourseClosure = getCourseClosure;
const addCourseClosure = async (supabase, obj) => {
    const updateObj = _.cloneDeep(obj);
    const { data: { user }, } = await supabase.auth.getUser();
    if (user?.id) {
        updateObj.modified_by = user?.id;
        updateObj.created_by = user?.id;
    }
    delete updateObj.created_by_user;
    delete updateObj.modified_by_user;
    const { data, error } = await supabase
        .from("course_closures")
        .insert([updateObj]);
    if (!error)
        return data;
    return error;
};
exports.addCourseClosure = addCourseClosure;
const deleteCourseClosure = async (supabase, id) => {
    const { data, error } = await supabase
        .from("course_closures")
        .delete()
        .eq("id", id);
    if (!error)
        return data;
    return error;
};
exports.deleteCourseClosure = deleteCourseClosure;
const updateCourseClosure = async (supabase, obj) => {
    const updateObj = _.cloneDeep(obj);
    const { data: { user }, } = await supabase.auth.getUser();
    if (user?.id)
        updateObj.modified_by = user?.id;
    updateObj.modified_at = new Date();
    delete updateObj.created_by_user;
    delete updateObj.modified_by_user;
    const { data, error } = await supabase
        .from("course_closures")
        .update(updateObj)
        .eq("id", updateObj.id);
    if (!error)
        return data;
    return error;
};
exports.updateCourseClosure = updateCourseClosure;
